import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, IconButton, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import PeopleIcon from '@mui/icons-material/People';
import SecurityIcon from '@mui/icons-material/Security';
import HistoryIcon from '@mui/icons-material/History';
import StoreIcon from '@mui/icons-material/Store';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BarChartIcon from '@mui/icons-material/BarChart';
import { AuthContext } from '../../contexts/AuthContext';

const SettingsModal = ({ open, onClose }) => {
    const navigate = useNavigate();
    const { auth } = useContext(AuthContext);

    // Convert to number to ensure stable comparisons
    const roleId = auth?.roleId ? Number(auth.roleId) : null;

    const handleNavigate = (path) => {
        onClose(); // Close modal first
        navigate(path);
    };

    const isAdmin = roleId === 1;
    const isGerente = roleId === 3;

    if (!isAdmin && !isGerente) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            disableEscapeKeyDown={false}
            disableEnforceFocus // Helps if navigating during closure
            PaperProps={{
                sx: { borderRadius: 3, position: 'relative' }
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, pr: 1 }}>
                <Typography variant="h6" fontWeight={700}>Configurações</Typography>
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                    size="medium" // Increased size
                    aria-label="close"
                    sx={{ color: 'text.secondary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                <List sx={{ py: 0 }}>
                    {isAdmin && (
                        <>
                            <Box sx={{ px: 2, pt: 2, pb: 1 }}>
                                <Typography variant="overline" color="text.secondary" fontWeight={700}>
                                    Administração
                                </Typography>
                            </Box>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/admin/users')}>
                                    <ListItemIcon><PeopleIcon /></ListItemIcon>
                                    <ListItemText primary="Usuários" secondary="Gerenciar usuários e acessos" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/admin/roles')}>
                                    <ListItemIcon><SecurityIcon /></ListItemIcon>
                                    <ListItemText primary="Permissões" secondary="Gerenciar cargos e regras" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/admin/audit')}>
                                    <ListItemIcon><HistoryIcon /></ListItemIcon>
                                    <ListItemText primary="Auditoria" secondary="Logs de atividades" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/bi/designer')}>
                                    <ListItemIcon><BarChartIcon /></ListItemIcon>
                                    <ListItemText primary="BI Designer" secondary="Criar e editar gráficos" />
                                </ListItemButton>
                            </ListItem>
                            <Divider sx={{ mt: 1 }} />
                        </>
                    )}

                    {(isAdmin || isGerente) && (
                        <>
                            <Box sx={{ px: 2, pt: 2, pb: 1 }}>
                                <Typography variant="overline" color="text.secondary" fontWeight={700}>
                                    Loja e Conta
                                </Typography>
                            </Box>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/profile')}>
                                    <ListItemIcon><ManageAccountsIcon /></ListItemIcon>
                                    <ListItemText primary="Configurações da Conta" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleNavigate('/loja/config')}>
                                    <ListItemIcon><StoreIcon /></ListItemIcon>
                                    <ListItemText primary="Configurações da Loja" />
                                </ListItemButton>
                            </ListItem>
                        </>
                    )}
                </List>
            </DialogContent>
            <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    fullWidth
                    sx={{
                        bgcolor: '#e3ad25',
                        color: '#000',
                        '&:hover': { bgcolor: '#d39d15' }
                    }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SettingsModal;
